import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2669c41e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["name", "required", "disabled", "placeholder", "readonly", "multiple", "accept"]
const _hoisted_3 = {
  key: 1,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["fs-5 fw-semibold mb-2", _ctx.required && 'required']),
          innerHTML: _ctx.label
        }, null, 10, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "file",
      class: _normalizeClass(["form-control form-control-solid", {required: _ctx.required, 'is-invalid': _ctx.errors.length || _ctx.errorFileType.length}]),
      name: _ctx.name,
      required: _ctx.required,
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      readonly: _ctx.readonly,
      multiple: _ctx.multiple,
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onUpload', $event)))
    }, null, 42, _hoisted_2),
    (_ctx.errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, i) => {
            return (_openBlock(), _createElementBlock("span", { key: i }, [
              _createTextVNode(_toDisplayString(error) + " ", 1),
              _hoisted_4
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorFileType.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.errorFileType) + " ", 1),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}